import React from 'react';

const MaintainerListItem = ({ first_name, last_name, email }) => (
  <li>
    <span>{`${first_name} ${last_name}`}</span> <span>{email}</span>
  </li>
)

export default MaintainerListItem



// WEBPACK FOOTER //
// ./src/components/Admin/Profile/MaintainerListItem.js